export default {"src":"/_next/static/media/zhk-white-sm.8732d590.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};